function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState, useEffect } from 'react';
import { CaretDownMinor, CancelSmallMinor } from '@shopify/polaris-icons';
import { useToggle } from '../../../../utilities/use-toggle.js';
import { useBreakpoints } from '../../../../utilities/breakpoints.js';
import { classNames } from '../../../../utilities/css.js';
import styles from './FilterPill.scss.js';
import { useI18n } from '../../../../utilities/i18n/hooks.js';
import { Text } from '../../../Text/Text.js';
import { HorizontalStack } from '../../../HorizontalStack/HorizontalStack.js';
import { UnstyledButton } from '../../../UnstyledButton/UnstyledButton.js';
import { Icon } from '../../../Icon/Icon.js';
import { Button } from '../../../Button/Button.js';
import { Popover } from '../../../Popover/Popover.js';
import { VerticalStack } from '../../../VerticalStack/VerticalStack.js';

function FilterPill(_ref) {
  var filterKey = _ref.filterKey,
      label = _ref.label,
      filter = _ref.filter,
      disabled = _ref.disabled,
      hideClearButton = _ref.hideClearButton,
      selected = _ref.selected,
      initialActive = _ref.initialActive,
      closeOnChildOverlayClick = _ref.closeOnChildOverlayClick,
      onRemove = _ref.onRemove,
      onClick = _ref.onClick;
  var i18n = useI18n();

  var _useBreakpoints = useBreakpoints(),
      mdDown = _useBreakpoints.mdDown;

  var elementRef = useRef(null);

  var _useToggle = useToggle(false),
      focused = _useToggle.value,
      setFocusedTrue = _useToggle.setTrue,
      setFocusedFalse = _useToggle.setFalse;

  var _useState = useState(initialActive),
      _useState2 = _slicedToArray(_useState, 2),
      popoverActive = _useState2[0],
      setPopoverActive = _useState2[1];

  useEffect(function () {
    var _node$parentElement, _parent$scroll;

    var node = elementRef.current;

    if (!node || !popoverActive) {
      return;
    }

    var parent = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.parentElement;

    if (!parent) {
      return;
    }

    (_parent$scroll = parent.scroll) === null || _parent$scroll === void 0 ? void 0 : _parent$scroll.call(parent, {
      left: node.offsetLeft
    });
  }, [elementRef, popoverActive]);

  var togglePopoverActive = function togglePopoverActive() {
    if (filter) {
      setPopoverActive(function (popoverActive) {
        return !popoverActive;
      });
    }

    if (onClick) {
      onClick(filterKey);
    }
  };

  var handleClear = function handleClear() {
    if (onRemove) onRemove(filterKey);
    setPopoverActive(false);
  };

  var buttonClasses = classNames(styles.FilterButton, selected && styles.ActiveFilterButton, popoverActive && styles.FocusFilterButton, focused && styles.focusedFilterButton, disabled && styles.disabledFilterButton);
  var clearButtonClassNames = classNames(styles.PlainButton, styles.clearButton);
  var toggleButtonClassNames = classNames(styles.PlainButton, styles.ToggleButton);
  var wrappedLabel = /*#__PURE__*/React.createElement("div", {
    className: styles.Label
  }, /*#__PURE__*/React.createElement(Text, {
    variant: mdDown ? 'bodyMd' : 'bodySm',
    as: "span"
  }, label));
  var activator = /*#__PURE__*/React.createElement("div", {
    className: buttonClasses
  }, /*#__PURE__*/React.createElement(HorizontalStack, {
    gap: "0",
    wrap: false
  }, /*#__PURE__*/React.createElement(UnstyledButton, {
    onFocus: setFocusedTrue,
    onBlur: setFocusedFalse,
    onClick: togglePopoverActive,
    className: toggleButtonClassNames,
    type: "button",
    disabled: disabled
  }, /*#__PURE__*/React.createElement(HorizontalStack, {
    wrap: false,
    align: "center",
    blockAlign: "center",
    gap: "0"
  }, selected ? /*#__PURE__*/React.createElement(React.Fragment, null, wrappedLabel) : /*#__PURE__*/React.createElement(React.Fragment, null, wrappedLabel, /*#__PURE__*/React.createElement("div", {
    className: styles.IconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    source: CaretDownMinor,
    color: "base"
  }))))), selected ? /*#__PURE__*/React.createElement(UnstyledButton, {
    onClick: handleClear,
    className: clearButtonClassNames,
    type: "button",
    "aria-label": i18n.translate('Polaris.FilterPill.clear'),
    disabled: disabled
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.IconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    source: CancelSmallMinor,
    color: "base"
  }))) : null));
  var clearButtonMarkup = !hideClearButton && /*#__PURE__*/React.createElement(Button, {
    onClick: handleClear,
    plain: true,
    disabled: !selected,
    textAlign: "left"
  }, i18n.translate('Polaris.FilterPill.clear'));

  if (disabled) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef
  }, /*#__PURE__*/React.createElement(Popover, {
    active: popoverActive && !disabled,
    activator: activator,
    key: filterKey,
    onClose: togglePopoverActive,
    preferredAlignment: "left",
    preventCloseOnChildOverlayClick: !closeOnChildOverlayClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.PopoverWrapper
  }, /*#__PURE__*/React.createElement(Popover.Section, null, /*#__PURE__*/React.createElement(VerticalStack, {
    gap: "1"
  }, filter, clearButtonMarkup)))));
}

export { FilterPill };